var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.dynamicComponent,_vm._b({tag:"component",on:{"submit":function($event){return _vm.formSubmit($event)}}},'component',{..._vm.componentData,'pageConfig': _vm.getPageConfigByName(this.page) },false))
}
var staticRenderFns = []

export { render, staticRenderFns }